Vendd.Scripts.load(function () {
    'use strict';

    var $wrapper = $('.js-custom-form');

    if ($wrapper.length <= 0)
        return;

    var checkConsents = function () {
        var data = [];

        var checkboxes = $('.form-row.consent.checkbox', $wrapper);
        $.each(checkboxes, function (e, el) {
            var chkbx = $('.checkbox-wrapper input', el);
            data.push({ type: chkbx.attr('id'), source: 'Custom Form Page', approved: chkbx.prop("checked") });
        });

        if (data.length > 0) {
            window.ConsentsManager.insertConsents(data);
        } else {
            submit();
        }
    };

    Vendd.MessageBus.subscribe(Vendd.CustomForms.Messages.SubmitSuccess, Vendd.CustomForms, function (envelope) {
        $(".error-container", $wrapper).html("");
        $(".response-container", $wrapper).html("");
        var response = envelope.message.data;
        if (!response.Success) {
            $.each(response.Errors, function (i, el) {
                $(".error-container", $wrapper).append($("<p>" + el + "</p>"));
            });
        } else {
            if (response.IsSaved) {
                $(".response-container", $wrapper).append($("<p>Data Saved</p>"));
            }
            if (response.IsSend) {
                $(".response-container", $wrapper).append($("<p>Data Send</p>"));
            }
        }
    });

    var submit = function () {
        
        var code = $wrapper.data("code");
        var model = $("form", $wrapper).serializeFormJSON();
        var data = { model: model, code: code };

        Vendd.MessageBus.publishAsync('CustomForm', new Vendd.CustomForms.Messages.Submit(data));
    };

    (function ($) {
        $.fn.serializeFormJSON = function () {

            var o = {};
            var a = this.serializeArray();
            $.each(a, function () {
                if (o[this.name]) {
                    if (!o[this.name].push) {
                        o[this.name] = [o[this.name]];
                    }
                    o[this.name].push(this.value || '');
                } else {
                    o[this.name] = this.value || '';
                }
            });
            return o;
        };
    })(jQuery);

    $('.js-send-custom-form').click(function (e) {
        e.preventDefault();

        if (LhApp.Context.IsConsentsEnabled) {
            checkConsents();
        } else {
            submit();
        }
    });

    Vendd.MessageBus.subscribe(Vendd.Consents.Messages.InsertConsents, $wrapper, submit);
});